import { getTaskPath, getTaskDetailPath } from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { taskActions } from "../reducers/task";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchTaskList = (type) => {
  return (dispatch) => {
    return apiService
      .get(getTaskPath(type))
      .then((response) => {
        dispatch(taskActions.fetchTaskList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchTaskDetail = (id) => {
  return (dispatch) => {
    return apiService
      .get(getTaskDetailPath(id))
      .then((response) => {
        dispatch(taskActions.fetchTaskDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("security.error.refresh"), { theme: "colored" });
  }
  toast.error(errorMessage, { theme: "colored" });
};
